<template>
  <v-app-bar
      color="transparent"
      outlined
      app
      fixed
      flat
      clipped-left
      style="z-index: 1000"
  >
    <div class="d-flex justify-space-between" style="width: 100%">
      <div>
        <d-btn blur @click="$router.push('/')">B-ZONE</d-btn>
      </div>
      <div>
        <div class="d-none d-lg-flex" style="gap: 2px">
          <d-btn blur :class="['about', 'index'].includes($route.name)  ? '' : 'un-active'" @click="$router.push('/about')">ABOUT US
          </d-btn>
          <d-btn blur :class="['services', 'index'].includes($route.name) ? '' : 'un-active'" @click="$router.push('/services')">
            SERVICES
          </d-btn>
          <d-btn blur :class="['contact', 'index'].includes($route.name) ? '' : 'un-active'" @click="$router.push('/contact')">CONTACTS
          </d-btn>
        </div>
      </div>
      <div>
        <d-btn blur class="d-none d-lg-flex" @click="openURL($store.getters.settings?.find(item => item.key === 'book_now_url')?.value)">BOOK NOW</d-btn>
      </div>


    </div>
    <div>
      <d-btn @click="expand = true" blur class="d-lg-none d-block">
        <v-icon>mdi-menu</v-icon>
      </d-btn>
    </div>
    <v-expand-transition>
      <div class="menu" v-show="expand">
        <d-btn lg  class="close-btn" @click="expand = false" blur>CLOSE</d-btn>
        <div class="menu-links">
          <router-link to="/">Home</router-link>
          <router-link to="/about">About us</router-link>
          <router-link to="/services">Services</router-link>
          <router-link to="/contact">Contacts</router-link>
          <a @click="openURL($store.getters.settings?.find(item => item.key === 'book_now_url')?.value)">Book now</a>
        </div>
        <div class="menu-items">
          <v-row justify="center">
            <v-col lg="3">
              <img src="/images/logo-outline.jpg" style="mix-blend-mode: hard-light" width="100%" alt="">
            </v-col>
          </v-row>
          <v-col lg="3" cols="12">
            <div class="d-flex justify-lg-end justify-center">
                <v-btn outlined color="white" small fab @click="openURL($store.getters.settings?.find(item => item.key === 'whatsapp')?.value)">
                    <v-icon size="16">mdi-whatsapp</v-icon>
                </v-btn>
                <v-btn outlined color="white" small fab @click="openURL($store.getters.settings?.find(item => item.key === 'instagram')?.value)"  class="ml-2">
                    <v-icon size="16">mdi-instagram</v-icon>
                </v-btn>
                <v-btn outlined color="white" small fab @click="openURL($store.getters.settings?.find(item => item.key === 'youtube')?.value)" class="ml-2">
                    <v-icon size="16">mdi-youtube</v-icon>
                </v-btn>
                <v-btn outlined color="white" small fab @click="openURL($store.getters.settings?.find(item => item.key === 'facebook')?.value)" class="ml-2">
                    <v-icon size="16">mdi-facebook</v-icon>
                </v-btn>
                <v-btn outlined color="white" small fab @click="openURL($store.getters.settings?.find(item => item.key === 'book_now_url')?.value)" class="ml-2">
                    <img src="/images/tiktok.webp" width="16px" alt="">
                </v-btn>
            </div>
          </v-col>
        </div>
      </div>
    </v-expand-transition>
  </v-app-bar>
</template>

<script>

import DBtn from "@/components/DBtn.vue";

export default {
  name: "AppBar",
  components: {DBtn},
  data(){
    return {
      expand: false
    }
  },
  watch: {
    '$route.name'(){
      this.expand = false
    }
  },
  methods: {
          openURL(url){
              window.open(url, "_blank")
          },
      booknow(){
          window.open(this.$store.getters.settings?.find(item => item.key === 'book_now_url')?.value, "_blank")
      }
  },
  computed: {
    user() {
      return this.$store.getters.auth_user
    }
  }
}
</script>

<style scoped>

.un-active {
  color: #FFFFFF66;
}

</style>